<mat-icon [className]="icon"></mat-icon>
<p
	color="textColor"
	class="data-change-indicator-text"
	><i>{{ text }}</i>
</p>
